/**
 * Suppress browser console output in production builds (default).
 *
 * Production: silences log, debug, info, warn. Set REACT_APP_HIDE_CONSOLE=false (or 0/no)
 * on the build to keep full console output (e.g. debugging a prod build locally).
 *
 * REACT_APP_HIDE_CONSOLE (optional, case-insensitive):
 * - all — also silence error, trace, dir, dirxml, table, group*
 * - Development only: true | 1 | yes enables the same suppression as prod default when
 *   NODE_ENV is not production.
 *
 * Import this file before any other application modules in src/index.js.
 */
const isProduction = process.env.NODE_ENV === 'production';

const raw = process.env.REACT_APP_HIDE_CONSOLE;
const mode = raw === undefined || raw === null ? '' : String(raw).trim().toLowerCase();

const optOut = mode === 'false' || mode === '0' || mode === 'no';
const silenceAll = mode === 'all';
const explicitDevSilence =
  !isProduction && (silenceAll || mode === 'true' || mode === '1' || mode === 'yes');

/** @type {'off' | 'verbose' | 'all'} */
let tier = 'off';
if (!optOut) {
  if (isProduction) {
    tier = silenceAll ? 'all' : 'verbose';
  } else if (explicitDevSilence) {
    tier = silenceAll ? 'all' : 'verbose';
  }
}

if (tier !== 'off') {
  const noop = () => {};

  /** @type {Array<keyof Console>} */
  const keys =
    tier === 'all'
      ? [
          'log',
          'debug',
          'info',
          'warn',
          'error',
          'trace',
          'dir',
          'dirxml',
          'table',
          'group',
          'groupCollapsed',
          'groupEnd',
        ]
      : ['log', 'debug', 'info', 'warn'];

  keys.forEach((key) => {
    if (typeof console[key] === 'function') {
      console[key] = noop;
    }
  });
}
